export const projects = [
    {
        id: 0,
        title: "Memory Studio",
        github: "https://github.com/zainabyahya/memory-studio",
        link: "https://whimsical-dango-822897.netlify.app",
        imgSrc: 'src/images/4.png'

    },
    {
        id: 1,
        title: "Fast Food Website",
        github: "https://github.com/zainabyahya/fastfood-website",
        link: "https://singular-croquembouche-627589.netlify.app",
        imgSrc: 'src/images/1.png'
    },
    {
        id: 2,
        title: "Pokemon Website",
        github: "https://github.com/zainabyahya/JS-Pokemon_API_Project",
        link: "https://cheery-druid-8b6438.netlify.app",
        imgSrc: 'src/images/2.png'
    }
]